import React from "react";

// Компонент для отображения карточки
const Card1 = ({ icon, title, value }) => {
    return (
        <div
            style={{
                display: "flex",
                alignItems: "center",
                border: "1px solid #ccc",
                borderRadius: "8px",
                padding: "16px",
                boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                backgroundColor: "#f8faff",
                width: "300px",
            }}
        >
            {/* Значок */}
            <div style={{ fontSize: "24px", marginRight: "16px" }}>{icon}</div>
            {/* Текст */}
            <div>
                <div style={{ fontSize: "16px", marginBottom: "8px" }}>{title}</div>
                <div style={{ fontWeight: "bold", fontSize: "14px" }}>{value}</div>
            </div>
        </div>
    );
};

const Card2 = ({ icon, title, value, color, bgColor }) => {
    return (
        <div
            className={`flex flex-col items-center justify-center rounded-lg p-6 shadow-md w-64 ${bgColor}`}
        >
            <div className={`text-4xl ${color} mb-2`}>{icon}</div>
            <div className={`text-lg font-medium ${color}`}>{title}</div>
            <div className={`text-xl font-bold ${color}`}>{value} / 10</div>
        </div>
    );
};

const Card = ({ icon: Icon, title, value, color, bgColor }) => {
    return (
        <div className={`card border-0 zoom-in bg-${bgColor}-subtle shadow-none w-64 p-6 rounded-lg`}>
            <div className="card-body text-center">
                <Icon size={50} color={`var(--bs-${color})`} className="mb-3" />
                <p className={`fw-semibold fs-3 text-${color} mb-1`}>{title}</p>
                <h5 className={`fw-semibold text-${color} mb-0`}>{value} / 10</h5>
            </div>
        </div>
    );
};

export default Card;
